module.exports = __webpack_public_path__ + "img/maas_bg6.5e413a61.png";